<template>
  <BaseTooltip
    ref="tooltip"
    :position="position"
    :arrow-position="arrowPosition"
    :hide-on-content-click="true"
    interactive
    trigger="click"
    tabindex="-1"
  >
    <template #trigger>
      <BaseButton v-if="isTextButton" size="small" outline>
        <slot name="button-label" />
      </BaseButton>

      <BaseButtonIcon
        v-if="isMoreButton"
        size="small"
        aria-label="show more options"
        v-bind="triggerOptions"
      >
        <MoreIcon />
      </BaseButtonIcon>
      <BaseButtonIcon
        v-if="isEditButton"
        size="small"
        outline
        aria-label="show more options"
        :class="{ 'edit-button--shadow': shadow }"
      >
        <PencilIcon />
      </BaseButtonIcon>
    </template>

    <template #content>
      <ul class="menu">
        <slot name="menu-items" />
      </ul>
    </template>
  </BaseTooltip>
</template>

<script>
import MoreIcon from '../icon_components/MoreIcon.vue'
import PencilIcon from '../icon_components/PencilIcon.vue'
import BaseButton from './base/BaseButton.vue'
import BaseButtonIcon from './base/BaseButtonIcon.vue'
import BaseTooltip from './base/BaseTooltip.vue'

export default {
  components: {
    BaseButton,
    BaseButtonIcon,
    BaseTooltip,
    MoreIcon,
    PencilIcon,
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    position: {
      type: String,
      required: false,
      default: 'bottom',
    },
    arrowPosition: {
      type: String,
      required: false,
      default: 'end',
    },
    shadow: {
      type: Boolean,
      required: false,
      default: false,
    },
    triggerOptions: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    isTextButton() {
      return this.type === 'text'
    },
    isMoreButton() {
      return this.type === 'more'
    },
    isEditButton() {
      return this.type === 'edit'
    },
  },
}
</script>

<style scoped lang="scss">
.menu {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-height: 90vh;
  overflow-y: auto;
}

.edit-button--shadow {
  box-shadow: 0 0 14px rgba(0, 0, 0, 0.2);
}
</style>
